import { ChangeDetectorRef, Component } from '@angular/core';
import { AProgessBarWizardComponent } from '../../../components/common/progressbarwizard/iprogressbar.wizard.component';
import { TranslatedString } from '../../../models/translatedstring.model';
import { DataPreviewService } from '../../../services/data.preview.service';
import { SmartSyncService } from '../../../services/smart.sync.service';

@Component({
    selector: 'siw-source-table-page',
    templateUrl: './siw.source.table.page.html',
    styleUrls: ['./siw.source.table.page.css']
})
export class SmartIntegrationWizardSourceTablePage extends AProgessBarWizardComponent {
    UseCase: any;
    SelectedTable: any;
    SearchText: string;
    FilteredTables = [];

    get ShowContentBorder(): boolean {
        return this.UseCase != null;
    }

    get CanStepForward(): boolean {
        return this.UseCase && this.UseCase.Tables &&
            this.UseCase.Tables.some((t: any) => t.Fields && t.Fields.some((f: any) => f.Selected));
    }

    private static TranslateElement(element: any) {
        if (element) {
            if (element.Caption) {
                element.TranslatedCaption = TranslatedString.GetTranslation(element.Caption);
            } else {
                element.TranslatedCaption = element.Name;
            }
        }
    }

    constructor(private cdRef: ChangeDetectorRef, private service: SmartSyncService, private preview: DataPreviewService) {
        super();
    }
    OnWizardStateSet(): void {
        if (this.WizardState) {
            if (this.WizardState.SelectedUseCase) {
                if (!this.WizardState.LoadedUseCases) {
                    this.WizardState.LoadedUseCases = {};
                }
                this.UseCase = this.WizardState.LoadedUseCases[this.WizardState.SelectedUseCase.ID];
                if (this.UseCase) {
                    this.onSearchChanged();
                } else {
                    this.service.GetUseCase(this.WizardState.SelectedUseCase.ID).subscribe(x => {
                        if (x) {
                            SmartIntegrationWizardSourceTablePage.TranslateElement(x);
                            if (x.Tables) {
                                x.Tables.forEach((t: any) => {
                                    SmartIntegrationWizardSourceTablePage.TranslateElement(t);
                                    if (t.Fields) {
                                        t.Fields.forEach((f: any) => {
                                            SmartIntegrationWizardSourceTablePage.TranslateElement(f);
                                            f.Selected = true;
                                        });
                                        t.SelectedFieldCount = t.Fields.length;
                                    }
                                });
                            }
                            this.WizardState.LoadedUseCases[this.WizardState.SelectedUseCase.ID] = x;
                            this.UseCase = x;
                            this.onSearchChanged();
                            this.cdRef.detectChanges();
                        }
                    });
                }
            }
        }
    }

    SelectTable(table: any) {
        this.SelectedTable = table;
        if (table && !table.Data && this.WizardState.SelectedDataSource) {
            const body = {
                Name: table.Name,
                ContainerType: 'evidanza.MiddleWare.Shared.Container.ContainerView',
                Parameters: []
            };
            if (table.Schema) {
                body['Options'] = {
                    Schema: table.Schema
                };
            }
            if (table.Fields) {
                body['Fields'] = [...table.Fields];
            }
            this.preview.GetPreview(this.WizardState.SelectedDataSource.Id, body, 20).subscribe((result) => {
                table.Data = result;
                this.cdRef.detectChanges();
            });
        }
    }

    onSearchChanged() {
        let list = [];
        if (this.UseCase && this.UseCase.Tables) {
            if (this.SearchText) {
                const toLower = this.SearchText.toLowerCase();
                list = this.UseCase.Tables.filter((x: any) => x.TranslatedCaption.includes(toLower));
            } else {
                list = [...this.UseCase.Tables];
            }
        }
        this.FilteredTables = list;
        this.cdRef.detectChanges();
    }

    updateTable() {
        if (this.SelectedTable && this.SelectedTable.Fields) {
            this.SelectedTable.SelectedFieldCount = this.SelectedTable.Fields.filter((x: any) => x.Selected).length;
            this.cdRef.detectChanges();
        }
    }
}
